import { Button, Form, Modal, message } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import UiDropDown from "../../Common/UiDropDown/UiDropDown";
import useForm from "../../Common/hooks/useForm";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import { saveChangeRMDetails } from "../../../redux/ChangeRm/action";
import useSession from "../../CustomLogout/useSession";

import "./PartnerMenu.css";

const ChangeRM = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const handleSessionExpired = useSession();

  const { state, onChangeTextHandler, setState } = useForm();
  const [form] = Form.useForm();
  const FormItem = Form.Item;
  const [saveLoading, setSaveLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
    setDrawerOpen(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setDrawerOpen(false);
    form.resetFields();
  };

  const rmListData =
    props.rmUserList?.length > 0
      ? props.rmUserList.map((el) => ({
          label: el.fullName,
          value: el.userId,
        }))
      : [];

  const rmName = props.row?.original?.assignedRmUserName;
  const companyName = props.row?.original?.partnerFirmName;

  const handleChangeSelect = (val) => {
    setState({
      ...state,
      assignedRMUserName: {
        id: val.value,
        name: val.label,
      },
    });
  };

  const handleChangeRM = () => {
    setSaveLoading(true);
    const dataChange = {
      partnerFirmID: props.row?.original?.partnerFirmId,
      assignedRMUserName: state.assignedRMUserName.name,
      assignedRMID: state.assignedRMUserName.id,
    };

    props
      .saveChangeRMDetails({
        values: dataChange,
        access_token: props.access_token,
      })
      .then((res) => {
        setSaveLoading(false);
        if (res && res.status === 200) {
          message.success("Saved");
          setDrawerOpen(false);
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            setSaveLoading(false);

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        setSaveLoading(false);
      });
  };

  return (
    <div>
      {/* <p
        style={{ cursor: "pointer", color: "#00b1b1" }}
        onClick={() => {
          showModal();
          props.hide && props.hide();
        }}
      >
        Change RM
      </p> */}

      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="changeRM"
          form={form}
          onFinish={handleChangeRM}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Change RM" />
              </Col>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={6}>
              <p className="change-rm-text">The Current RM for</p>
              <p> {companyName}</p>
              <p className="color-blue">
                {">"} {rmName}
              </p>
            </Col>
            <Col md={6}>
              <p>To change the RM, select from below list</p>
              <FormItem
                name="assignedRMUserName"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Please Select RM",
                  },
                ]}
              >
                <UiDropDown data={rmListData} onChange={handleChangeSelect} />
              </FormItem>
            </Col>
          </Row>{" "}
          <Row className="mt-4">
            <Col md={12} className="d-flex justify-content-end">
              {saveLoading && (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              )}
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveChangeRMDetails: (data) => dispatch(saveChangeRMDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    rmUserList: state && state.partner && state.partner.rmUserList,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeRM);
